<template lang="pug">
  #top
    .flex
      .box.left
        .row
          .label ① 現金・預貯金
          .text
            v-text-field.no_spin(v-model="price01" maxlength="10" type="number")
          .unit 万円
        .row
          .label
            | ② 有価証券
          .text
            v-text-field.no_spin(v-model="price02" maxlength="10" type="number")
          .unit 万円
        .row
          .memo （上場株、オーナー株式、非上場株式、証券、投資信託、等）
        .row
          .label ③ 死亡保険金
          .text
            v-text-field.no_spin(v-model="price03" maxlength="10" type="number")
          .unit 万円
        .row
          .label
            | ④ 不動産
            span （土地・家屋）
          .text
            v-text-field.no_spin(v-model="price04" maxlength="10" type="number")
          .unit 万円
        .row
          .label ⑤ その他財産
          .text
            v-text-field.no_spin(v-model="price05" maxlength="10" type="number")
          .unit 万円
        .row
          .label ⑥ 債務等
          .text
            v-text-field.no_spin(v-model="price06" maxlength="10" type="number")
          .unit 万円
      .box.right
        .row
          .price_title 総額
          .price
            | {{price}}
            span 万円
          .price_formula （① + ② + ③ + ④ + ⑤ - ⑥）
    .style
      .text_area
        span 本人は現在、
        span 生前・死後のどちらですか？
      .buttons
        button(:class="{'add':style === 1}" @click="style01") 生前
        button(:class="{'add':style === 2}" @click="style02") 死後
    .button_area
      button.blue_button.show_pc(@click="go_step03") 遺産相続シミュレーション結果を表示する
      button.blue_button.show_sp(@click="go_step03")
        |遺産相続シミュレーション
        br
        |結果を表示する
      BackButton.back_button

</template>

<script lang="js">
import BackButton from '@/components/module/BackButton.vue';
import step03Module from '@/module/step03Module';

export default {
  components: {
    BackButton,
  },
  data: () => ({
    price01: '',
    price02: '',
    price03: '',
    price04: '',
    price05: '',
    price06: '',
    deathZyozei: 0,
    style: 1,
  }),
  computed: {
    price() {
      const price = this.totalPrice;
      const formatter = new Intl.NumberFormat('ja-JP');
      return formatter.format(price);
    },
    totalPrice() {
      return this.parseInt(this.price01)
          + this.parseInt(this.price02)
          + this.parseInt(this.price03)
          + this.parseInt(this.price04)
          + this.parseInt(this.price05)
          - this.parseInt(this.price06);
    },
  },
  methods: {
    go_step03() {
      const json = localStorage.getItem('_isan_data');
      let family = {};
      if (json) {
        family = JSON.parse(json);
      }
      const memberCount = step03Module.targetMemberCount(family);
      this.deathKouzyo = step03Module.deathKouzyo(this.parseInt(this.price03), memberCount);

      const saveParam = {
        price: this.totalPrice,
        price01: this.parseInt(this.price01),
        price02: this.parseInt(this.price02),
        price03: this.parseInt(this.price03),
        price04: this.parseInt(this.price04),
        price05: this.parseInt(this.price05),
        price06: this.parseInt(this.price06),
        deathKouzyo: this.parseInt(this.deathKouzyo),
        style: this.style,
      };
      localStorage.setItem('_isan_price', JSON.stringify(saveParam));
      this.$router.push('/step03');
    },
    parseInt(value) {
      const val = parseInt(value, 10);
      if (!val) {
        return 0;
      }
      return val;
    },
    style01() {
      this.style = 1;
    },
    style02() {
      this.style = 2;
    },
    zeroIsBlank(val) {
      if (val === '0') {
        return '';
      }
      if (val === 0) {
        return '';
      }
      return val;
    },
  },
  created() {
    const jsonStr = localStorage.getItem('_isan_price');
    if (jsonStr) {
      const json = JSON.parse(jsonStr);
      this.price01 = this.zeroIsBlank(json.price01);
      this.price02 = this.zeroIsBlank(json.price02);
      this.price03 = this.zeroIsBlank(json.price03);
      this.price04 = this.zeroIsBlank(json.price04);
      this.price05 = this.zeroIsBlank(json.price05);
      this.price06 = this.zeroIsBlank(json.price06);
      this.style = json.style;
    }
  },
  mounted() {
    this.$emit('change_mode', 2);
  },
};
</script>

<style lang="sass" scoped>
#top
  display: flex
  flex-direction: column
  width: $max-width
  margin: auto
  padding-bottom: 70px
  .flex
    display: flex
    width: 100%
    .box
      &:nth-of-type(1)
        width: 55%
        border-right: solid 1px $light-gray
        flex-direction: row
      &:nth-of-type(2)
        width: 45%
        .row
          height: 100%
          flex-direction: column
          div
            max-width: 300px
            width: 100%
          .price_title
            padding-left: 10px
          .price
            padding-left: 10px
            font-size: 36px
            span
              font-size: 24px
              margin-left: 20px
      .row
        display: flex
        justify-content: center
        align-items: center
        .label
          margin-left: 0px
          width: 190px
          font-size: 20px
          span
            display: block
            font-size: 12px
            padding-left: 20px
        .text
          width: 240px
        .unit
          width: 70px
          font-size: 20px
          margin-left: 20px
        .memo
          width: 100%
          font-size: 16px
          margin-top: -15px
          color: $main-red
  .style
    background-color: $light-gray
    padding: 30px
    margin: 30px 20px 0 20px
    .text_area
      display: flex
      justify-content: center
      flex-wrap: wrap
      margin-bottom: 30px
    .buttons
      display: flex
      justify-content: center
      button
        border: solid 1px #000
        background-color: $white
        padding: 10px 30px
        transition: 0.4s
        &:nth-child(1)
          margin-right: 10px
        &:nth-child(2)
          margin-left: 10px
      .add
        background-color: $deep-blue
        color: $white
        border: solid 1px $deep-blue
.button_area
  margin-top: 20px
  flex-direction: column
  align-items: center
  .blue_button
    width: 500px
    height: 60px
  .back_button
    margin-top: 20px
    width: 500px
    height: 60px
.show_pc
  display: inline-block
.show_sp
  display: none

@media screen and (max-width: $break-header)
  #top
    flex-direction: column
    height: 100%
    min-height: auto
    width: 100%
    .flex
      flex-direction: column
      .box
        &:nth-of-type(1)
          width: 100%
          border: none
        &:nth-of-type(2)
          width: 100%
          .row
            margin-left: 38px
            div
              max-width: 100%
            .price_title
              padding-left: 10px
            .price
              padding-left: 10px
              font-size: 36px
              span
                font-size: 24px
                margin-left: 20px
      .row
        display: flex
        justify-content: center
        align-items: center
        padding: 0 20px
        .label
          margin-left: 0
          width: 100%
          font-size: 20px
          span
            display: block
            font-size: 12px
            padding-left: 20px
        .text
          width: 70%
          position: relative
          &:after
            content: "万円"
            position: absolute
            font-size: 20px
            right: -40px
            top: 20px
        .unit
          display: none
  .button_area
    margin-top: 40px
    padding-bottom: 100px
    button
      width: 90%!important
      height: 80px!important
  .show_pc
    display: none
  .show_sp
    display: inline-block

@media screen and (max-width: 710px)
  #top
    .flex
      .box
        .row
          flex-wrap: wrap
          .label
            width: 100%

</style>

<style lang="sass">
.no_spin
  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button
    -webkit-appearance: none!important
    margin: 0
  input
    -moz-appearance: textfield!important
</style>
